<template>
  <profile-card title="Followers">
    <div class="tw-grid tw-divide-y tw-divide-gray-200">
      <v-follow-item v-for="other_user in users" :user="other_user" :key="other_user.id">
        <button v-on:click.prevent="remove(other_user)" class="tw-text-white tw-bg-red tw-border-red tw-rounded tw-border tw-px-4 tw-py-1 tw-font-bold">
          Remove
        </button>
      </v-follow-item>
    </div>
    <div v-if="users.length === 0" class="tw-py-40 tw-text-center tw-text-gray-500 tw-text-3xl tw-uppercase">No Followers</div>
  </profile-card>
</template>
<script>
  export default {
    props: {
      initialUsers: {},
      user: {},
    },
    data : v => ({
      users : v.initialUsers
    }),
    methods: {
      remove(user) {
        axios.delete(`/api/v1/follower/${user.id}`, {
          params: {api_token: this.user.api_token},
        }).then(resp => {
          this.users = this.users.filter(item => item.id !== user.id)
          Vue.$toast.success('Follower Removed')
        })
      }
    }
  }
</script>
